module.exports = __webpack_public_path__ + "img/vueschool-logo.f438c98e.svg";